import { AccountCreatedProps } from './AccountCreated.props';

import AccountCreatedView from './AccountCreated.view';

const AccountCreatedContainer = (props: AccountCreatedProps) => {
  return <AccountCreatedView />;
};

export default AccountCreatedContainer;
